<template>
  <div>
    <Modal v-model="modal" :width="modalWidth" class-name="export-modal" :closable="false" :mask-closable="false">
      <div class="flow-modal-title" slot="header">
        <span style="font-size: 17px">{{ title }}</span>
        <span @click="closeModal()" style="position: absolute; right: 6px; cursor: pointer">
          <i class="ivu-icon ivu-icon-ios-close"></i>
        </span>
      </div>
      <div class="form">
        <Form ref="printOptionForm" :label-width="150" :model="printOption" :rules="ruleValidate" label-colon>
          <Row style="padding-top: 10px;">
            <Col span="11">
              <FormItem label="是否打印标题" prop="isPrintTitle">
                <RadioGroup v-model="printOption.isPrintTitle" size="large">
                  <Radio label="0">否</Radio> &nbsp;
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
            <Col span="11">
              <FormItem label="是否打印序号" prop="isPrintSn">
                <RadioGroup v-model="printOption.isPrintSn" size="large">
                  <Radio label="0">否</Radio> &nbsp;
                  <Radio label="1">是</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="22">
              <FormItem label="标题" prop="printTitle" :rules="{ required: printOption.isPrintTitle == '1' ? true : false, message: '标题不能为空', trigger: 'blur,change' }">
                <Input v-model="printOption.printTitle" maxlength="50" show-word-limit />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="22">
              <FormItem label="选择打印字段" prop="printFields">
                <CheckboxGroup v-model="printOption.printFields" size="large">
                  <Checkbox v-for="item in allowPrintFields" :key="item.name" :label="item.name">{{ item.description }}</Checkbox>
                </CheckboxGroup>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormItem label="打印数据页设置" prop="pageRange">
                从&nbsp;
                <InputNumber :min="1" :max="pageCount" :precision="0" v-model="printOption.pageRange.fromPageNo" style="width: 100px" />
                &nbsp;页&nbsp; 至&nbsp;
                <InputNumber :min="1" :max="pageCount" :precision="0" v-model="printOption.pageRange.toPageNo" style="width: 100px" />&nbsp;页 （&nbsp;共&nbsp;{{ pageCount }}&nbsp;页）
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <div slot="footer" class="model-footer">
        <Button size="large" @click="closeModal">取消</Button>
        <Button type="primary" size="large" :loading="modal_loading" @click="confirmPrint">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import Qs from 'qs'
import { validate } from 'uuid'

export default {
  name: 'grid-print-opt',
  props: {
    modalWidth: {
      type: Number,
      default: 900
    },
    modalHeight: {
      type: Number,
      default: 600
    },
    gridAllShowFields: {
      type: Array,
      default() {
        return []
      }
    },
    selectedRows: {
      type: Array,
      default() {
        return []
      }
    },
    modelName: {
      type: String,
      default: ''
    },
    rowMark: {
      type: String,
      default: ''
    },
    pageSize: {
      type: Number,
      default: 10
    },
    gridRequestParams: {
      type: Object,
      default() {
        return null
      }
    },
    printMaxCount: {
      type: Number,
      default: 2000
    },
    printOption: {
      type: Object,
      default() {
        return {
          isPrintTitle: '0',
          isPrintSn: '1',
          printTitle: '',
          printFields: [],
          pageRange: {
            fromPageNo: 1,
            toPageNo: 1
          }
        }
      }
    }
  },
  data() {
    const validatePrintFields = function (rule, value, callback) {
      if (!value || value.length <= 0) {
        callback(new Error('请选择打印字段'))
      } else {
        callback()
      }
    };
    return {
      modal: true,
      title: '打印数据',
      totalCount: 0,
      modal_loading: false,
      ruleValidate: {
        pageRange: [{ validator: this.validatePageRange, trigger: 'blur,change' }],
        printFields: [{ validator: validatePrintFields, trigger: 'blur,change' }]
      }
    }
  },
  mounted() {
    // 打印标题
    this.printOption.printTitle = this.modelName || ''
    // 查询导出数据共有多少页
    this.queryPrintDataCount()
    // 默认选中所有字段
    this.defCheckedAllFields()
  },
  computed: {
    allowPrintFields() {
      if (this.gridAllShowFields) {
        return this.gridAllShowFields.filter(el => el.isExport === '1')
      } else {
        return []
      }
    },
    pageCount() {
      return Math.ceil(this.totalCount / this.pageSize)
    }
  },
  methods: {
    queryPrintDataCount() {
      if (!this.gridRequestParams) {
        this.$Notice.error({
          title: '错误提示',
          desc: '查询数据参数为空'
        })
      } else {
        let params = { ...this.gridRequestParams }
        params.pageNo = 1
        params.pageSize = 0
        this.$store.dispatch('postRequest', { url: '/bsp-com/com/datagrid/getQueryPageData', params: params }).then(resp => {
          if (resp.success) {
            this.totalCount = resp.total
            // 设置默认的导出结束页
            if (this.totalCount > this.exportMaxCount) {
              this.printOption.pageRange.toPageNo = Math.floor(this.printMaxCount / this.pageSize)
            } else {
              this.printOption.pageRange.toPageNo = Math.ceil(this.totalCount / this.pageSize)
            }
          } else {
            this.$Notice.error({
              title: '错误提示',
              desc: resp.msg
            })
          }
        })
      }
    },
    defCheckedAllFields() {
      if (this.allowPrintFields) {
        let allowPrintFieldNames = this.allowPrintFields.map(e => e.name)
        this.printOption.printFields.push(...allowPrintFieldNames)
      }
    },
    validatePageRange(rule, value, callback) {
      if (!value || !value.fromPageNo || !value.toPageNo) {
        callback(new Error('请设置导出数据页'))
        return
      }
      if (value.fromPageNo > value.toPageNo) {
        callback(new Error('导出起始页号不能大于结束页号'))
        return
      }else{
           callback()
      }
    },
    closeModal() {
      this.modal = false
      this.$emit('closeModal')
    },
    getPrintNum(toPageNo, fromPageNo) {
      // 如果是最后一页 判断最后一页多少条数据
      // 不是最后一页直接乘页码 (value.toPageNo - value.fromPageNo + 1) * this.pageSize
      let exportTotal = 0
      if (toPageNo == this.pageCount) {
        exportTotal = this.totalCount - (fromPageNo - 1) * this.pageSize
      } else {
        exportTotal = (toPageNo - fromPageNo + 1) * this.pageSize
      }
      console.log(exportTotal,this.pageCount,'this.pageCount()')
      return exportTotal
    },
    confirmPrint() {      
      this.$refs['printOptionForm'].validate(valid => {
        if (valid) {          
          this.modal_loading = true
          let opts = this.printOption
          let params = { ...this.gridRequestParams }
          params.isPrintTitle = opts.isPrintTitle
          params.isPrintSn = opts.isPrintSn
          params.printTitle = opts.printTitle || ''
          params.printFields = opts.printFields.join(',')
          params.fromPageNo = opts.pageRange.fromPageNo
          params.toPageNo = opts.pageRange.toPageNo
          params.pageSize = this.pageSize
          params.printMaxCount = this.printMaxCount    
          delete params.pageNo
          if (this.selectedRows && this.selectedRows.length > 0 && this.rowMark) {
            let rowMarkLowerCase = this.rowMark.toLowerCase()
            let rowMarkValArr = this.selectedRows.map(row => row[rowMarkLowerCase])
            params['rowMarkVals'] = rowMarkValArr.join(',')
          }
          console.log((params.toPageNo - params.fromPageNo + 1) * this.pageSize, this.printMaxCount,this.pageCount, 'this.selectedRows.length')
          let num = this.getPrintNum(params.toPageNo, params.fromPageNo)
          params.totalPage= Math.ceil(num / this.pageSize)// 导出列表数据总页数,
          params.totalNum=this.totalCount  // 打印列表数据数
          params.totalPrintNum=num //打印数据数
          if (num > 2000) {
            this.$Message.error('打印数据条数超出限制')
            this.modal_loading = false
          } else {
            let url = '/bsp-com/com/datagrid/getPdfData'
            this.downFile(params,url,false,opts )
          }
          
        } else {
          this.$Message.error('表单验证失败')
        }
      })
    },
    downFile(params,url,tag,opts){
      this.$store
            .dispatch('downloadPostRequest', {
              url: url,
              params: Qs.stringify(params),
              responseType: 'blob'
            })
            .then(resp => {
              const data = resp
              console.log(data,'data')
              if (data['type'] === 'text/plain' || data['type'] === 'application/json') {
                // 导出失败，返回的是错误消息
                data.text().then(msg => {
                  this.$Notice.error({
                    title: '错误提示',
                    desc: msg ? msg : '打印列表数据异常'
                  })
                })
                this.modal_loading = false
              } else {
                // 打印成功，返回的是要打印的文件
                const url = window.URL.createObjectURL(data)
                window.open(url)
                this.modal_loading = false
                //this.closeModal()
              }
            })
            .catch(error => {
              if (error) {
                console.log(error)
              }
              this.modal_loading = false
            })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .export-modal .ivu-modal-body,
/deep/ .export-modal .ivu-modal-header {
  padding: 0 !important;
}
/deep/ .ivu-modal-body {
  max-height: 440px;
  overflow-y: auto;
}
/deep/ .export-modal .ivu-modal-footer {
  padding: 8px 18px 8px 18px;
}
/deep/ .export-modal .ivu-icon-ios-close {
  font-size: 32px;
  line-height: 40px;
}
/deep/ .export-modal .ivu-modal-footer {
  background: #f7faff;
  border-color: #cee0f0;
}

/* 自定义弹窗底部按钮样式重置 */
.export-modal .model-footer /deep/ .ivu-btn-primary {
  font-size: 16px;
  min-width: 80px;
  height: 36px;
  opacity: 1;
  background: #2b5fd9;
  border-radius: 2px;
  margin: 0 8px;
}
.export-modal .flow-modal-title {
  height: 40px;
  background: #2b5fda;
  width: 100%;
  text-indent: 1em;
  color: #fff;
  line-height: 40px;
}
.export-modal .model-footer button {
  font-size: 16px;
  min-width: 80px;
  height: 36px;
  opacity: 1;
  border-radius: 2px;
  margin: 0 8px;
}

/deep/ .ivu-checkbox-group-item {
  width: 160px;
  font-size: 16px;
}

/deep/ .ivu-form .ivu-form-item-label {
  font-size: 16px;
}

/deep/ .ivu-form-item-content {
  font-size: 16px;
}

/deep/ .export-modal *::-webkit-scrollbar {
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

/deep/ .export-modal *::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #b7c7dd;
}

/deep/ .export-modal *::-webkit-scrollbar-track {
  border-radius: 3px;
  background: #ededed;
}
</style>


// WEBPACK FOOTER //
// src/component/data-grid/components/grid-print-opt.vue